<div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
<div class="servicios-slide">
    <div class="servicio-item" *ngFor="let servicio of (data | async).Servicios" [routerLink]="['/', 'servicios', servicio.Link]">
        <img class="icon" [src]="servicio.Imagen" [alt]="servicio.Titulo">
        <h4>{{ servicio.Titulo }}</h4>        
    </div>
</div>